import { render, staticRenderFns } from "./GestionConfigurationService.vue?vue&type=template&id=b191b0a2&scoped=true&"
import script from "./GestionConfigurationService.vue?vue&type=script&lang=js&"
export * from "./GestionConfigurationService.vue?vue&type=script&lang=js&"
import style0 from "./GestionConfigurationService.vue?vue&type=style&index=0&id=b191b0a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b191b0a2",
  null
  
)

export default component.exports